<template>
    <v-layout class="content-layout" column>
        <label class="secondary--text display-1 font-weight-bold">Продавцы</label>
        <sellers-list/>
    </v-layout>
</template>

<script>
    import SellersList from "../components/sellers/SellersList";

    export default {
        components: {SellersList},
        name: "sellers-view"
    }
</script>

<style scoped>

</style>